import type { TargetProduct } from '@post-office/message-templates-common--puma/in-app/cjn-nav4/types';
import {
	ConfluenceCloudCcpId,
	type ValidProductCcpId,
} from '@post-office/universal-contracts/message-template-metadata';

export const targetProduct: { productId: ValidProductCcpId; productKey: TargetProduct } = {
	productId: ConfluenceCloudCcpId,
	productKey: 'confluence',
};
